import { Grid, GridItem } from "@chakra-ui/react";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchStatusOfTimeline } from "../../api/timelineService";
import { fetchUserData, getCompanyDetails } from "../../api/userService";
import useCustomToast from "../../customHooks/useCustomToast";
import { setCompanyName } from "../../Redux/companySlice";
import { setUserDetails, setUserTimelineStep } from "../../Redux/userSlice";
import ChatBox from "../ChatBox/ChatBox";
import DocumentsShimmer from "../Shimmer/DocumentsShimmer";
import UserDetailsTab from "./UserDetailsTab";
import UserInformation from "./UserInformation/UserInformation";

const UserDetails = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showToast = useCustomToast();
  const { previousWindowRoute } = useSelector((store) => {
    return store.userDetails;
  });

  // excutes the below method, before the browser starts painting
  useLayoutEffect(() => {
    const fetchTimelineFromServer = async () => {
      try {
        if (!localStorage.getItem("access_token")) {
          setLoading(false);
          navigate("/");
          return;
        }
        const timelineResponse = await fetchStatusOfTimeline();
        const { current_step } = timelineResponse.data.status;
        if (current_step === 5 && !(previousWindowRoute === "documents")) {
          dispatch(setUserTimelineStep(current_step));
          navigate("/documents");
        }
      } catch (error) {
        showToast(error.message, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchTimelineFromServer();
  }, [navigate, dispatch, previousWindowRoute, showToast]);

  useEffect(() => {
    const fetchDataFromServer = async () => {
      try {
        const userDataResponse = await fetchUserData();
        const { email, name, phone_number, uuid } = userDataResponse[0].data;
        const companyDataResponse = await getCompanyDetails();
        const { name: companyName } = companyDataResponse[0].data;
        const newUserData = {
          firstName: name?.split(/\s+/)[0] || "",
          lastName: name?.split(/\s+/)[1] || "",
          userEmail: email || "",
          userPhone: phone_number?.split("+91")[1] || "",
          customerUUID: uuid,
        };
        dispatch(setUserDetails(newUserData));
        dispatch(setCompanyName(companyName));
      } catch (error) {
        showToast(error.message, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchDataFromServer();
  }, [showToast, dispatch]);

  return loading ? (
    <DocumentsShimmer />
  ) : (
    <Grid
      templateColumns={{ base: "repeat(1, 1fr)", md: "20% 45% 35%" }}
      gap={2}
      minH="93vh"
      alignItems="stretch"
      mt={5}
    >
      <GridItem h="100%" py={4} ml={7}>
        <UserDetailsTab />
      </GridItem>
      <GridItem w="100%" p={4}>
        <UserInformation />
      </GridItem>
      <GridItem w="100%" h="100%" p={4} mr={10}>
        <ChatBox />
      </GridItem>
    </Grid>
  );
};

export default UserDetails;
